// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__29TnQ","approved":"Status_approved__2rHFw","rejected":"Status_rejected__1tIDZ","expired":"Status_expired__1C0ia","label":"Status_label__2pgFB"};